import type { ProtectedRoute } from '../../../protectedRoutes.types.ts';
import { ROUTES } from './routes.ts';

const PROTECTED_ROUTES: ProtectedRoute[] = [{ prefix: ROUTES.MY_ACCOUNT.ROOT }, { prefix: ROUTES.LOTTO.PURCHASES }, { prefix: ROUTES.OFFERS }, { prefix: ROUTES.FREE_PLAY }];

export { PROTECTED_ROUTES };
